import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { TextField } from '../../../../components/fields';
import { required, email, minLength8 } from '../../../../utilities/validation';
import { FormattedMessage } from 'react-intl';
import messages from '../../../../text/messages';

class Login extends React.Component {
    render() {
        const { handleSubmit, submitting, invalid } = this.props;

        return (
            <form onSubmit={handleSubmit}>
                <div className="form-group">
                    <Field
                        name="email"
                        id="email-login"
                        validate={[required, email]}
                        hideErrors
                        component={TextField}
                        type="email"
                        placeholder={messages.email}
                    />
                </div>
                <div className="form-group">
                    <Field
                        name="password"
                        id="password-login"
                        component={TextField}
                        validate={[required, minLength8]}
                        hideErrors
                        type="password"
                        placeholder={messages.password}
                    />
                </div>
                <div className="form-group">
                    <button type="submit" id="login-button" className="btn btn-success btn-block" disabled={submitting || invalid}>
                        <FormattedMessage {...messages.login} />
                    </button>
                </div>
            </form>
        );
    }
}

Login.defaultProps = {
    handleSubmit: undefined,
    submitting: false
};

Login.propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    submitting: PropTypes.bool
};

export default reduxForm({ form: 'Login', destroyOnUnmount: true })(Login);



// WEBPACK FOOTER //
// ./src/pages/account/forms/login/index.jsx